import { Flex, Loader } from 'components';
import './style.scss';

function StageLoading() {
  return (
    <Flex
      alignItems='center'
      justifyContent='center'
      className='stage-loading-3qO4'
    >
      <Loader
        size='default'
        color='red'
        variant='line'
      />

      <div className='filler-drJP' />
    </Flex>
  );
}

export default StageLoading;
